const Maprisk = require("./maprisk-drawing-library.js");

class DrawingLibrary {
	constructor(type, map, eventBus, userOverlays) {
		switch (type) {
			case "maprisk":
				return new Maprisk(map, eventBus, userOverlays);
			default:
				console.log(
					"drawingLibrary error: invalid drawing library type specified."
				);
				break;
		}
	}
}

module.exports = DrawingLibrary;
